/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../lib/schemas.js";
import { Result as SafeParseResult } from "../types/fp.js";
import {
  AppSchemasV2TransactionCountListTransactionCountMeta,
  AppSchemasV2TransactionCountListTransactionCountMeta$inboundSchema,
  AppSchemasV2TransactionCountListTransactionCountMeta$Outbound,
  AppSchemasV2TransactionCountListTransactionCountMeta$outboundSchema,
} from "./appschemasv2transactioncountlisttransactioncountmeta.js";
import {
  AppSchemasV2TransactionCountTransactionCountMetric,
  AppSchemasV2TransactionCountTransactionCountMetric$inboundSchema,
  AppSchemasV2TransactionCountTransactionCountMetric$Outbound,
  AppSchemasV2TransactionCountTransactionCountMetric$outboundSchema,
} from "./appschemasv2transactioncounttransactioncountmetric.js";
import { SDKValidationError } from "./errors/sdkvalidationerror.js";

export type AppSchemasV2TransactionCountListTransactionCountResponse = {
  data: Array<AppSchemasV2TransactionCountTransactionCountMetric>;
  meta: AppSchemasV2TransactionCountListTransactionCountMeta;
};

/** @internal */
export const AppSchemasV2TransactionCountListTransactionCountResponse$inboundSchema:
  z.ZodType<
    AppSchemasV2TransactionCountListTransactionCountResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    data: z.array(
      AppSchemasV2TransactionCountTransactionCountMetric$inboundSchema,
    ),
    meta: AppSchemasV2TransactionCountListTransactionCountMeta$inboundSchema,
  });

/** @internal */
export type AppSchemasV2TransactionCountListTransactionCountResponse$Outbound =
  {
    data: Array<AppSchemasV2TransactionCountTransactionCountMetric$Outbound>;
    meta: AppSchemasV2TransactionCountListTransactionCountMeta$Outbound;
  };

/** @internal */
export const AppSchemasV2TransactionCountListTransactionCountResponse$outboundSchema:
  z.ZodType<
    AppSchemasV2TransactionCountListTransactionCountResponse$Outbound,
    z.ZodTypeDef,
    AppSchemasV2TransactionCountListTransactionCountResponse
  > = z.object({
    data: z.array(
      AppSchemasV2TransactionCountTransactionCountMetric$outboundSchema,
    ),
    meta: AppSchemasV2TransactionCountListTransactionCountMeta$outboundSchema,
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace AppSchemasV2TransactionCountListTransactionCountResponse$ {
  /** @deprecated use `AppSchemasV2TransactionCountListTransactionCountResponse$inboundSchema` instead. */
  export const inboundSchema =
    AppSchemasV2TransactionCountListTransactionCountResponse$inboundSchema;
  /** @deprecated use `AppSchemasV2TransactionCountListTransactionCountResponse$outboundSchema` instead. */
  export const outboundSchema =
    AppSchemasV2TransactionCountListTransactionCountResponse$outboundSchema;
  /** @deprecated use `AppSchemasV2TransactionCountListTransactionCountResponse$Outbound` instead. */
  export type Outbound =
    AppSchemasV2TransactionCountListTransactionCountResponse$Outbound;
}

export function appSchemasV2TransactionCountListTransactionCountResponseToJSON(
  appSchemasV2TransactionCountListTransactionCountResponse:
    AppSchemasV2TransactionCountListTransactionCountResponse,
): string {
  return JSON.stringify(
    AppSchemasV2TransactionCountListTransactionCountResponse$outboundSchema
      .parse(appSchemasV2TransactionCountListTransactionCountResponse),
  );
}

export function appSchemasV2TransactionCountListTransactionCountResponseFromJSON(
  jsonString: string,
): SafeParseResult<
  AppSchemasV2TransactionCountListTransactionCountResponse,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      AppSchemasV2TransactionCountListTransactionCountResponse$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'AppSchemasV2TransactionCountListTransactionCountResponse' from JSON`,
  );
}
